export const linkChildren = (allLinks, isSubscriber) => {
  if (!allLinks || !allLinks.length) return allLinks;

  const nonSubscriberlinks = allLinks.filter(link => !link.name.startsWith('SUB: '));
  const subscriberLinks = allLinks.filter(link => link.name.startsWith('SUB: '));

  const links = isSubscriber ? subscriberLinks : nonSubscriberlinks;

  return links;
}

export const linkName = (name) => {
  return name.replace('SUB: ', '');
}